/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lifecycle_Archive_Product_BodyInputs */

const en_lifecycle_archive_product_body = /** @type {(inputs: Lifecycle_Archive_Product_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The product becomes read-only and disappears from the sidebar, lists and search. You can unarchive it at any time.`)
};

const de_lifecycle_archive_product_body = /** @type {(inputs: Lifecycle_Archive_Product_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Produkt wird schreibgeschützt und verschwindet aus Seitenleiste, Listen und Suche. Du kannst es jederzeit aus dem Archiv holen.`)
};

/**
* | output |
* | --- |
* | "The product becomes read-only and disappears from the sidebar, lists and search. You can unarchive it at any time." |
*
* @param {Lifecycle_Archive_Product_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lifecycle_archive_product_body = /** @type {((inputs?: Lifecycle_Archive_Product_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lifecycle_Archive_Product_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lifecycle_archive_product_body(inputs)
	return en_lifecycle_archive_product_body(inputs)
});